import { navigateToSanitizedUrl } from '@wix/da-url';

// ---- urls && window navigation
export const navigate = url => {
  if (typeof window !== 'undefined') {
    navigateToSanitizedUrl(url);
  }
};
